/**
 * UTM Source Tracking Utility
 *
 * Captures and stores utm_source parameter for attribution tracking.
 * Uses first-touch attribution (existing value is not overwritten).
 */

const UTM_STORAGE_KEY = 'yoyo_utm_source';

/**
 * Capture and store utm_source from URL (first-touch attribution, no overwrite)
 */
export function captureUtmSource(): void {
  if (typeof window === 'undefined') return;

  const existing = localStorage.getItem(UTM_STORAGE_KEY);
  if (existing) return; // First-touch attribution, don't overwrite

  const params = new URLSearchParams(window.location.search);
  const source = params.get('utm_source')?.trim().slice(0, 100);
  if (source) {
    localStorage.setItem(UTM_STORAGE_KEY, source);
  }
}

/**
 * Get stored utm_source value
 */
export function getStoredUtmSource(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(UTM_STORAGE_KEY);
}

/**
 * Clear stored utm_source (call after successful booking)
 */
export function clearUtmSource(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(UTM_STORAGE_KEY);
}
